<div class="log-reg-side-bg">
    <div class="row">
        <!-- <div class="col-lg-7 ">
            <div class="cntntRightArea">
                <h3>It's time to put your</h3>
                <h2>Peace of mind first</h2>
                <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the
                    visual form of a document or a typeface without relying on XYZ</p>
            </div>
        </div> -->
        <div class="col-lg-5 box-align">
            <div class="login-box">
                <div class="">
                    <div class="card-header text-center mb-3 border-0">
                        <a [routerLink]="['/']" class="h1"><img src="../../../assets/img/aero_lounge-logo.png"></a>
                    </div>
                    <div class="card-body">
                        <form [formGroup]="loginForm" (ngSubmit)="signIn()" autocomplete="off">
                            <div class="mb-3">
                                <input formControlName="email" type="email" class="form-control" placeholder="Email" />
                                <div *ngIf="loginForm.controls['email'].invalid && (loginForm.controls['email'].dirty || loginForm.controls['email'].touched)"
                                    class="alert alert-danger mt-2">
                                    <div
                                        *ngIf="loginForm.controls['email'].errors?.['required'] || loginForm.controls['email'].errors?.['email']">
                                        Please enter valid email id
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <input formControlName="password" type="password" class="form-control"
                                    placeholder="Password" />
                                <div *ngIf="loginForm.controls['password'].invalid && (loginForm.controls['password'].dirty || loginForm.controls['password'].touched)"
                                    class="alert alert-danger mt-2">
                                    <div *ngIf="loginForm.controls['password'].errors?.['required']">
                                        Please enter your password
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 mb-3">
                                    <button type="submit" class="btn btn-primary d-block w-100 green-bg"
                                        [disabled]="loginForm.invalid">Login</button>
                                </div>
                                <!-- <div class="col-12 mb-3">
                                <button class="btn btn-primary d-block w-100"  [routerLink]="['/register']"> Register a new membership</button>                            
                            </div> -->
                            </div>

                            <div class="row">
                                <!-- <div class="col-6">
                                <div class="icheck-primary">
                                    <input type="checkbox" id="remember" [checked]="isRememberMeOn" (change)="remenberMe($event.target.checked)"/>
                                    <label for="remember"> Remember Me </label>
                                </div>
                            </div> -->
                                <div class="col-6 text-right">
                                    <p class="mb-1">
                                        <a class="fp" [routerLink]="['/forgot-password']"> Forgot password</a>
                                    </p>
                                </div>
                            </div>

                            <div class="social-auth-links text-center mb-3">
                                <!-- <button type="button"
                                class="mb-2"
                                (click)="loginByFacebook()"
                            >
                                <i class="fab fa-facebook mr-2"></i>
                                Sign in using Facebook
                            </button> -->
                                <!-- <button type="button"
                                (click)="loginByGoogle()"
                            >
                                <i class="fab fa-google mr-2"></i>
                                <asl-google-signin-button type='standard' size='medium' logo_alignment="center" *ngIf="!user"></asl-google-signin-button>
                                Sign in using Google+
                            </button> -->
                                <!-- <div class="google-custom-btn w-100"  id="google-btn"></div> -->
                            </div>
                        </form>
                    </div>
                    <!-- /.login-card-body -->
                </div>
            </div>
        </div>
    </div>
</div>